import { SagaIterator } from "@redux-saga/core";
import { startSubmit, stopSubmit } from "redux-form";
import { call, put, takeLatest } from "redux-saga/effects";

import { claimSearchAction } from "@/App/actions";
import { PageAlert } from "@/App/components";
import { ActionTypes } from "@/App/constants/actionTypes";
import { TransactionCode } from "@/App/constants/constants";
import apiService from "@/App/service";
import { ClaimTypes } from "@/types";

interface ClaimDataTypes {
  claim: ClaimTypes.Claim;
}

function* getClaim(payload: {}): Generator {
  return yield apiService({
    url: "/claim/get",
    method: "POST",
    data: payload,
  });
}

function* searchClaim(data: ClaimTypes.ClaimSearchOptions): Generator {
  return yield apiService({
    url: "/claim/list",
    method: "POST",
    data,
  });
}

function formatData(data: Array<ClaimDataTypes>): Array<ClaimDataTypes> {
  data.forEach(function (item) {
    item.claim.response_transaction_code_formatted = TransactionCode[item.claim.response_transaction_code];
    item.claim.transaction_response_status_formatted = TransactionCode[item.claim.transaction_response_status_formatted];
  });

  return data;
}

function* getClaimWorker(action: ReturnType<typeof claimSearchAction.userGetClaim>): SagaIterator {
  const { userGetClaimResults } = claimSearchAction;
  const { payload } = action;
  const { showPageAlert } = PageAlert;

  try {
    const claim = yield call(getClaim, payload);

    yield put(userGetClaimResults(claim));
  } catch (error) {
    const { data: { message = "" } = {} } = error;
    yield put(showPageAlert({ show: true, type: "error", message: message || error }));
  }
}

function* searchForClaimWorker(action: ReturnType<typeof claimSearchAction.userSearchForClaims>): SagaIterator {
  const { userSearchForClaimsResults } = claimSearchAction;
  const { payload, formName } = action;
  const { showPageAlert } = PageAlert;

  try {
    yield put(startSubmit(formName));
    const { results, result_count } = yield call(searchClaim, payload);

    yield put(
      userSearchForClaimsResults({
        result_count: result_count,
        results: formatData(results),
      }),
    );
    yield put(stopSubmit(formName));
  } catch (error) {
    const { data: { message = "Unknown error." } = {} } = error;
    yield put(stopSubmit(formName));
    yield put(showPageAlert({ show: true, type: "error", message: message || error }));
  }
}

export default function* searchForClaimWatcher(): SagaIterator {
  yield takeLatest(ActionTypes.SEARCH_FOR_CLAIM, searchForClaimWorker);
  yield takeLatest(ActionTypes.GET_CLAIM, getClaimWorker);
}
